<template>
  <div v-loading="loading">
    <el-card>
      <div class="title">
        <span>叫号设置</span>
      </div>
      <div class="main">
        <el-row>
          <el-col
            ><div class="base-info">
              <span class="line"></span>
              <span class="bold-size">叫号基础设置</span>
            </div></el-col
          >
        </el-row>
        <div class="box">
          <div class="item">
            <div class="left bold-size">设置名称</div>
            <div class="right bold-size">参数设置及说明</div>
          </div>
          <div class="item">
            <div class="left">叫号取餐开关</div>
            <div class="right">
              <el-switch
                v-model="functionFlag"
                active-color="#f59a23"
                inactive-color="#ccc"
              ></el-switch
              ><span style="color: rgb(153, 153, 153); margin-left: 12px"
                >开启后，才可使用叫号取餐功能</span
              >
            </div>
          </div>
          <div class="item">
            <div class="left">通知手机点餐客人取餐</div>
            <div class="right">
              <el-switch
                v-model="notifyFlag"
                active-color="#f59a23"
                inactive-color="#ccc"
              ></el-switch
              ><span style="color: rgb(153, 153, 153); margin-left: 12px"
                >整单点餐后，自动通知微信手机点餐的客人取餐</span
              >
            </div>
          </div>
          <div class="item">
            <div class="left">语音叫号开关</div>
            <div class="right">
              <el-switch
                v-model="speechFlag"
                active-color="#f59a23"
                inactive-color="#ccc"
              ></el-switch
              ><span style="color: rgb(153, 153, 153); margin-left: 12px"
                >开启后，叫号时将会在相应叫号端触发语音提示</span
              >
            </div>
          </div>
          <div class="item">
            <div class="left">语音叫号内容</div>
            <div class="right">
              <input
                id="myInput"
                v-model="speechContent"
                :readonly="readOnly"
                :class="{ 'native-input': true, edit: !readOnly }"
                type="text"
              />
              <span
                v-if="readOnly"
                @click="edit"
                style="color: #f59a23; cursor: pointer"
                >编辑</span
              >
              <span
                @click="btn"
                v-if="!readOnly"
                style="margin-left: 5px; color: #f59a23; cursor: pointer"
                >确定</span
              >
            </div>
          </div>
          <div class="item">
            <div class="left">叫号次数</div>
            <div class="right">
              <el-select
                :popper-append-to-body="false"
                v-model="form.callNumber"
                class="my-select"
              >
                <el-option label="叫号一次" value="1"></el-option>
                <el-option label="叫号两次" value="2"></el-option>
                <el-option label="叫号三次" value="3"></el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <div class="left">叫号语音速度</div>
            <div class="right">
              <el-select
                :popper-append-to-body="false"
                v-model="form.callSpeedType"
                class="my-select"
              >
                <el-option label="正常" value="1"></el-option>
                <el-option label="快速" value="2"></el-option>
                <el-option label="慢速" value="3"></el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <div class="left">预计等待时间</div>
            <div class="right">
              <span style="color: rgb(153, 153, 153)">每一桌预计等待时长 </span>
              <el-input-number
                v-model="form.waitTime"
                controls-position="right"
                :min="1"
              >
              </el-input-number>
              <span style="color: rgb(153, 153, 153)"> 分钟</span>
            </div>
          </div>
          <div class="item">
            <div class="left">设置取号范围</div>
            <div class="right">
              <el-input-number
                v-model="form.markRange"
                controls-position="right"
                :min="1"
              >
              </el-input-number>
              <span style="color: rgb(153, 153, 153)">
                米内，可进行小程序取餐</span
              >
            </div>
          </div>
          <div class="item">
            <div class="left">小程序取号开关</div>
            <div class="right">
              <el-switch
                v-model="applet"
                active-color="#f59a23"
                inactive-color="#ccc"
              ></el-switch
              ><span style="color: rgb(153, 153, 153); margin-left: 12px"
                >开启后，才可使用小程序叫号功能</span
              >
            </div>
          </div>
          <div class="item">
            <div class="left">取号开放时间段</div>
            <div class="right">
              <el-time-picker
                is-range
                value-format="HH:mm:ss"
                v-model="dateRange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                placeholder="选择时间范围"
              >
              </el-time-picker>
            </div>
          </div>
        </div>
      </div>
      <div class="foot">
        <el-button @click="queryOne" class="my-btn reset">恢复默认</el-button>
        <el-button
          class="my-btn"
          @click="save"
          style="background: #ffbd00; color: #000"
          >保存设置</el-button
        >
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading:true,
      speechContent: "#取餐号#请您用餐啦", //语音叫号内容
      readOnly: true,
      dateRange: null,
      merchantCode: localStorage.getItem("merchantCode"),
      merchantName: localStorage.getItem("merchantName"),
      functionFlag: true, //叫号取餐开关
      notifyFlag: true, //通知手机点餐客人取餐
      speechFlag: true, //语音叫号开关
      applet: true, //小程序取号开关
      form: {
        merchantCode: localStorage.getItem("merchantCode"),
        merchantName: localStorage.getItem("merchantName"),
        functionFlag: 1, //叫号取餐开关
        notifyFlag: 1, //通知手机点餐客人取餐
        speechFlag: 1, //语音叫号开关
        speechContent: "#取餐号#请您用餐啦", //语音叫号内容
        callNumber: "1", //叫号次数
        callSpeedType: "1", //叫号语音速度
        waitTime: "10", //计算等待时间
        markRange: "50", //设置取号范围
        applet: 0, //小程序取号开关
      },
    };
  },
  methods: {
    queryOne() {
      var data = {
        merchantCode: this.merchantCode,
        merchantName: this.merchantName,
      };
      this.loading=true
      this.$http.post("/merchantLineConfig/queryOne", data).then((res) => {
        console.log(res);
        this.form=res.data.data
        console.log(this.form,'-----')
        this.functionFlag=this.unChange(this.form.functionFlag)
        this.notifyFlag=this.unChange(this.form.notifyFlag)
        this.speechFlag=this.unChange(this.form.speechFlag)
        this.applet=this.unChange(this.form.applet)
        if(this.form.speechContent==''){this.form.speechContent="#取餐号#请您用餐啦"}
        this.speechContent=this.form.speechContent
        this.dateRange=[]
        this.dateRange[0]=this.form.takeStartTime
        this.dateRange[1]=this.form.takeEndTime
       this.form.callNumber=this.form.callNumber.toString()
       this.loading=false
      });
    },
    save() {
        this.loading=true
      this.form.functionFlag = this.changeData(this.functionFlag);
      this.form.notifyFlag = this.changeData(this.notifyFlag);
      this.form.speechFlag = this.changeData(this.speechFlag);
      this.form.applet = this.changeData(this.applet);
      if (this.dateRange == null) {
        this.form.takeStartTime = null;
        this.form.takeEndTime = null;
      } else {
        this.form.takeStartTime = this.dateRange[0];
        this.form.takeEndTime = this.dateRange[1];
      }
      this.$http.post("/merchantLineConfig/save", this.form).then((res) => {
        console.log(res);
        if(res.data.code==200){
            this.$message({type:'success',message:"保存成功"})
        }else{
            this.$message.error(res.data.message)
        }
        this.queryOne()
      });

    },
    changeData(val) {
      if (val == true) {
        return 1;
      } else {
        return 0;
      }
    },
    unChange(val) {
      if (val == 1) {
        return true;
      } else {
        return false;
      }
    },
    edit() {
      this.readOnly = false;
      let input = document.querySelector("#myInput");
      input.focus();
    },
    btn() {
      this.form.speechContent = this.speechContent;
      this.readOnly = true;
    },
  },
  created() {
    this.queryOne();
  },
};
</script>

<style lang="less" scoped>
/deep/.el-card__body {
  padding: 20px 0;
}
.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
  padding-right: 30px;
  color: #333;
  padding-bottom: 20px;
  border-bottom: 1px solid #e8e8e8;
  span {
    margin-left: 30px;
  }
}
.main {
  padding: 20px;
  height: 65vh;
  overflow: auto;
  .line {
    display: inline-block;
    width: 4px;
    height: 18px;
    line-height: 18px;
    background-color: orange;
    margin-right: 5px;
    border-radius: 2px;
    margin-bottom: -2px;
  }
  .box {
    margin-top: 12px;
    border: 1px solid #e5e5e5;
    .item {
      display: flex;
      > div {
        font-size: 14px;
        padding: 10px 12px;
        border-bottom: 1px solid #e5e5e5;
      }
      .left {
        box-sizing: border-box;
        width: 260px;
        background: #f7f7f7;
        border-right: 1px solid #e5e5e5;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        position: relative;
      }
      .right {
        flex: 1;
      }
    }
  }
}

.foot {
  padding: 10px 32px;
  // margin-top: 12px;
  text-align: right;
  background: transparent;
  border-top: 1px solid #e8e8e8;
  border-radius: 0 0 4px 4px;
  .my-btn {
    height: 32px;
    padding: 0 15px;
    border-radius: 5px;
  }
  .my-btn.reset:active,.my-btn.reset:focus,.my-btn.reset:hover{
    background-color: #fff;
    color: #606266;
  }
}
/deep/.bold-size {
  font-weight: 700;
}
/deep/ .my-select {
  width: 150px;
}
/deep/ .el-select .el-input.is-focus .el-input__inner {
  border-color: #f59a23 !important;
}
/deep/ .el-select .el-input__inner:focus {
  border-color: #f59a23 !important;
}
/deep/ .el-select-dropdown__item.selected {
  color: #f59a23 !important;
}
/deep/ .native-input {
  box-sizing: border-box;
  outline: none;
  border: transparent;
  color: rgb(153, 153, 153);
  width: 145px;
  height: 30px;
  line-height: 30px;
  padding-left: 15px;
  padding-right: 5px;
  border-radius: 4px;
}
/deep/ .native-input.edit {
  border: 1px solid #dcdfe6;
}
</style>